import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AdminAlertRequest, AdminAlertResponse, AdminAlertService, AlertDto } from 'src/shared/service-proxies/service-proxies';
import { PageHelperService } from '../helpers/page-helper.service';
import { DropDownListItem } from '../inventory/inventory.component';
import { PagebaseComponent } from '../pagebase/pagebase.component';
import { ApplicationStatusService } from '../services/application-status.service';
import { SessionStorageService } from '../services/session-storage.service';
import { PagingModel } from '../widgets/models/paging-model';
import { CustomerSettings } from '../services/customer-settings-service';

export class SortData {
  field: string;
  direction: 'ascending' | 'descending' | 'none';
}
export class DialogData {
  title: string;
  text: string;
  showCancel: boolean = true;
  showDataChanged: boolean = true;
  showOtherChanged: boolean = true;
  showNoChangesNeeded: boolean = true;
  dataChanged: boolean = null;
  otherChanged: boolean = null;
  noChangesNeeded: boolean = null;
  changedType: null;
  isAcknowedge: false;
}
export interface AlertDtoModel extends AlertDto {
  state: boolean,
  priorityClass: string;
}
@Component({
    selector: 'app-admin-alerts',
    templateUrl: './admin-alerts.component.html',
    styleUrls: ['./admin-alerts.component.scss'],
    standalone: false
})
export class AdminAlertsComponent extends PagebaseComponent implements OnInit, OnDestroy {
  loading: boolean = true;
  apiCall = null;
  alerts: AlertDtoModel[] = [];
  customers: DropDownListItem[] = [];
  types: DropDownListItem[] = [];
  statuses: DropDownListItem[] = [
    { id: "0", name: "In Progress" },
    { id: "1", name: "On Hold" },
    { id: "2", name: "Closed" },
    { id: "3", name: "Pending" }
  ];
  autogenAlertIds: number[] = [1, 28];
  blackboxes: DropDownListItem[] = [];
  selectedCustomerId: string[] = [];
  selectedStatusId: number[] = [0];
  selectedAlertTypeId: number[] = [];
  selectedBlackboxId: string[] = [];
  tableSort: SortData = {
    field: "created",
    direction: "descending"
  }
  paging: PagingModel;
  page: number = 1;
  orderBy: string = "Created"
  
  constructor(public dialog: MatDialog, private router: Router, private alertService: AdminAlertService, private sessionStorageService: SessionStorageService, pageHelperService: PageHelperService, applicationStatusService: ApplicationStatusService, private customerSettings: CustomerSettings) {
    super(pageHelperService, applicationStatusService, customerSettings, "Admin Alerts");
  }

  ngOnInit() {
    if (!this.sessionStorageService.getItem("admin-alerts-selectedStatusId")) {
      this.sessionStorageService.setItem("admin-alerts-selectedStatusId", JSON.stringify(this.selectedStatusId));
    }
  }
   
  ngOnDestroy(): void {
    this.reset();
  }

  getData() {
    this.loading = true;
    this.setIsLoading(this.loading);
    var params = this.getAlertsRequest([], []);
    this.apiCall = this.alertService.getByStatus(
      params
    ).subscribe(data => {
      let pageData = this.getModel(data.items);
      this.loading = false;
      this.loadListData(data)
      this.setIsLoading(this.loading);
      this.paging = new PagingModel(data.currentPage, data.hasNext, data.hasPrevious, data.pageSize, data.totalPages, data.totalTotalItemCount)
      this.alerts = pageData;
    }, error => {
      debugger;
    });
  }

  updateAlerts(params) {
    this.loading = true;
    this.setIsLoading(this.loading);    
    this.apiCall = this.alertService.updateStatus(
      params
    ).subscribe(data => {
      let pageData = this.getModel(data.items);
      this.loading = false;
      this.loadListData(data)
      this.setIsLoading(this.loading);
      this.paging = new PagingModel(data.currentPage, data.hasNext, data.hasPrevious, data.pageSize, data.totalPages, data.totalTotalItemCount)
      this.alerts = pageData;
    }, error => {
      debugger;
    });
  }

  changeState(id, state) {
    console.log(id);
    console.log(state);
  }

  reset(): void {
  }

  checkAll(ev) {
    this.alerts.forEach(x => x.state = ev.target.checked)
  }

  isAllChecked() {
    return this.alerts.every(_ => _.state);
  }

  dropdownChanged(opened) {
    if (!opened) {
      this.getData();
    }
  }

  getModel(alerts: AlertDto[]) : AlertDtoModel[] {
    const models: AlertDtoModel[] = [];
    alerts.forEach(dto => {
      let model: AlertDtoModel = dto as AlertDtoModel;
      switch(dto.priorityId) {
      case 1:
        model.priorityClass = 'priority critical-alert';
        break;
      case 2:
        model.priorityClass = 'priority high-alert';
        break;
      case 3:
        model.priorityClass = 'priority medium-alert';
        break;
      case 4:
        model.priorityClass = 'priority low-alert';
        break;
      }
      
      models.push(model)
    });

    return models;
  }

  customerChange(newValue) {
    if (newValue.length > 0) {
      this.sessionStorageService.setItem("admin-alerts-selectedCustomerId", JSON.stringify(newValue));
    } else {
      this.sessionStorageService.removeItem("admin-alerts-selectedCustomerId")
    }
  }

  statusChange(newValue) {
    if (newValue.length > 0) {
      this.sessionStorageService.setItem("admin-alerts-selectedStatusId", JSON.stringify(newValue));
    } else {
      this.sessionStorageService.removeItem("admin-alerts-selectedStatusId")
    }
  }

  typeChange(newValue) {
    if (newValue.length > 0) {
      this.sessionStorageService.setItem("admin-alerts-selectedAlertTypeId", JSON.stringify(newValue));
    } else {
      this.sessionStorageService.removeItem("admin-alerts-selectedAlertTypeId")
    }
  }

  blackboxChange(newValue) {
    if (newValue.length > 0) {
      this.sessionStorageService.setItem("admin-alerts-selectedBlackboxId", JSON.stringify(newValue));
    } else {
      this.sessionStorageService.removeItem("admin-alerts-selectedBlackboxId")
    }
  }

  refresh() {
    this.getData();
  }

  getSortIcon(column): string {
    if(column == this.tableSort.field) {
      if (this.tableSort.direction == 'ascending') {
        return "&#9650;"
      } else {
        return "&#9660;"
      }
    }

    return '';
  }

  sortTable(field: string) {
    let sortItem = this.sessionStorageService.getItem("admin-alerts-table-sort");
    let sort: SortData;
    if (sortItem) {
      sort = JSON.parse(sortItem);
      if (sort.field == field) {
        sort.direction = sort.direction == "ascending" ? "descending" : "ascending";
      } else {
        sort =   {
          field: field,
          direction: "descending"
        }
      }
    } else {
      sort = {
        field: field,
        direction: "descending"
      }
    }

    this.sessionStorageService.setItem("admin-alerts-table-sort", JSON.stringify(sort));
    this.getData();
  }

  loadListData(data: AdminAlertResponse) {
    // Get list data from the provided data
    const customers: DropDownListItem[] = [];
    const types: DropDownListItem[] = [];
    const blackboxes: DropDownListItem[] = [];

    data.customers.forEach(item => {
      var customer = new DropDownListItem()
      customer.id = item.key;
      customer.name = item.value;
      customers.push(customer)
    })

    data.blackboxes.forEach(item => {
      var blackbox = new DropDownListItem()
      blackbox.id = item.key;
      blackbox.name = item.value;
      blackboxes.push(blackbox)
    })

    data.alertTypes.forEach(item => {
      var type = new DropDownListItem()
      type.id = item.key.toString();
      type.name = item.value;
      types.push(type)
    })
    
    this.customers = customers.sort(function (a, b) {
      if (a.name < b.name) { return -1; }
      if (a.name > b.name) { return 1; }
      return 0;
    })

    this.types = types.sort(function (a, b) {
      if (a.name < b.name) { return -1; }
      if (a.name > b.name) { return 1; }
      return 0;
    })

    this.blackboxes = blackboxes.sort(function (a, b) {
      if (a.name < b.name) { return -1; }
      if (a.name > b.name) { return 1; }
      return 0;
    })

    var selectedCustomerId = [];
    if (this.sessionStorageService.getItem("admin-alerts-selectedCustomerId")) {
      selectedCustomerId = JSON.parse(this.sessionStorageService.getItem("admin-alerts-selectedCustomerId"));
      this.selectedCustomerId = selectedCustomerId;
    }

    var selectedAlertTypeId = [];
    if (this.sessionStorageService.getItem("admin-alerts-selectedAlertTypeId")) {
      selectedAlertTypeId = JSON.parse(this.sessionStorageService.getItem("admin-alerts-selectedAlertTypeId"));
      this.selectedAlertTypeId = selectedAlertTypeId;
    }

    var selectedBlackboxId = [];
    if (this.sessionStorageService.getItem("admin-alerts-selectedBlackboxId")) {
      selectedBlackboxId = JSON.parse(this.sessionStorageService.getItem("admin-alerts-selectedBlackboxId"));
      this.selectedBlackboxId = selectedBlackboxId;
    }
  }

  alertsSelected() {
    return this.alerts.filter(a => a.state == true).length > 0
  }

  async actionClose(alertDto: AlertDtoModel) {
    if (!alertDto.actionUrl || !alertDto.actionDescription || alertDto.closedById) {
      return null;
    }

    if (this.autogenAlertIds.includes(alertDto.alertId)) {
        // Converts the route into a string that can be used 
        // with the window.open() function
        const url = this.router.serializeUrl(
          this.router.createUrlTree([alertDto.actionUrl])
        );

        window.open(alertDto.actionUrl, '_blank');
        
        return;
    }

    let message = alertDto.actionConfirmText + "\n\nThis will close the alert";
    let response: Response;
    
    if (alertDto.isActionPromptRequired) {
      let userInput = prompt(message);

      if (!userInput) {
        return false;
      }

      response = await fetch(alertDto.actionUrl + (userInput ? encodeURIComponent(userInput) : ""), { method: 'POST' });
    }
    else if (!alertDto.actionConfirmText || confirm(message)) {
      response = await fetch(alertDto.actionUrl, { method: 'POST' });
    }
    
    if (!response) {
      return false;
    }

    if (response.ok) {
      this.updateAlerts(this.getAlertsRequest([], [alertDto.id]))
      return true;
    }
    else {
      alert(alertDto.actionDescription + " was not successful: " + response.statusText)
    }

    return false;
  }

  acknowledge(alertId: number) {
    var text = alertId == null ? "Acknowledge Selected?" : "Acknowledge?";
    const dialogRef = this.dialog.open(DialogFromMenuExampleDialog, {
      width: '300px',
      data: {
        title: '',
        text: text,
        showDataChanged: false,
        showOtherChanged: false,
        dataChanged: null,
        otherChanged: null,
        isAcknowedge: true
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (alertId == null) {
          var selectedIds = this.alerts.filter(a => a.state == true).map(a => a.id);
          console.log(selectedIds);
          this.updateAlerts(this.getAlertsRequest(selectedIds, []))
        }
        else {
            this.updateAlerts(this.getAlertsRequest([alertId], []))
        }
      }
    });
  }

  close(alertId: number) {
    var text = alertId == null ? "Close Selected?" : "Close?";
    const dialogRef = this.dialog.open(DialogFromMenuExampleDialog, {
      width: '300px',
      data: {
        title: '',
        text: text,
        showNoChangesNeeded: true,
        showDataChanged: true,
        showOtherChanged: true,
        dataChanged: false,
        otherChanged: false
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log(result)
        if (alertId == null) {
          var selectedIds = this.alerts.filter(a => a.state == true).map(a => a.id);
          this.updateAlerts(this.getAlertsRequest([], selectedIds, result.changedType == "dataChanged", result.changedType == "otherChanged"))
        }
        else {
          this.updateAlerts(this.getAlertsRequest([], [alertId], result.changedType == "dataChanged", result.changedType == "otherChanged"))
        }
      }
    });
  }

  showDetails(alert: AlertDtoModel) {
    var content = alert.details.replace(/(?:\r\n|\r|\n)/g, '<br />');;
    if (alert.alertUrl != '') {
      content = content + `<br /><br /><a href="${alert.alertUrl}" target="_blank">Investigate</a>`;
    }

    const dialogRef = this.dialog.open(DialogFromMenuExampleDialog, {
      width: '500px',
      data: {
        title: alert.title,
        text: content,
        showCancel: false
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      
    });
  }

  changePage(self: any, page: number) {
    self.page = page;
    self.getData();
  }

  getAlertsRequest(acknowledge: number[], close: number[], dataChanged: boolean = null, otherChanged: boolean = null): AdminAlertRequest {
    var selectedStatusId = [];
    if (this.sessionStorageService.getItem("admin-alerts-selectedStatusId")) {
      selectedStatusId = JSON.parse(this.sessionStorageService.getItem("admin-alerts-selectedStatusId"));
      this.selectedStatusId = selectedStatusId;
    }

    var selectedCustomerId = [];
    if (this.sessionStorageService.getItem("admin-alerts-selectedCustomerId")) {
      selectedCustomerId = JSON.parse(this.sessionStorageService.getItem("admin-alerts-selectedCustomerId"));
      this.selectedCustomerId = selectedCustomerId;
    }

    var selectedAlertTypeId = [];
    if (this.sessionStorageService.getItem("admin-alerts-selectedAlertTypeId")) {
      selectedAlertTypeId = JSON.parse(this.sessionStorageService.getItem("admin-alerts-selectedAlertTypeId"));
      this.selectedAlertTypeId = selectedAlertTypeId;
    }

    var selectedBlackboxId = [];
    if (this.sessionStorageService.getItem("admin-alerts-selectedBlackboxId")) {
      selectedBlackboxId = JSON.parse(this.sessionStorageService.getItem("admin-alerts-selectedBlackboxId"));
      this.selectedBlackboxId = selectedBlackboxId;
    }

    let sortItem = this.sessionStorageService.getItem("admin-alerts-table-sort");
    let sort: SortData;
    if (sortItem) {
      sort = JSON.parse(sortItem);
    } else {
      sort = {
        field: "created",
        direction: "descending"
      }
    }

    this.tableSort = sort;

    return {
      customerIds: selectedCustomerId,
      status: selectedStatusId,
      alertsToAcknowledge: acknowledge,
      alertsToClose: close,
      alertTypeIds: selectedAlertTypeId,
      blackboxIds: selectedBlackboxId,
      pageId: this.page,
      pageSize: 50,
      isSortDecending: this.tableSort.direction != 'ascending',
      orderBy: this.tableSort.field,
      dataChanged: dataChanged,
      otherChanged: otherChanged
    }
  }
}
@Component({
    selector: 'dialog-from-menu-dialog',
    templateUrl: './admin-alerts-dialog.component.html',
    standalone: false
})
export class DialogFromMenuExampleDialog {
  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) {}
}
